import styled from 'styled-components';

export const RouteContainer = styled.div``;
